import link from './link';
import logo from './logo';

export default {
  link,
  logo,
};
